// Format phone number to E.164 format
export const toE164 = (phone) => {
  if (!phone) return '';

  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');

  // If starts with 0, assume Indonesian number, replace with +62
  if (digits.startsWith('0')) {
    return '+62' + digits.substring(1);
  }

  // If starts with 62, add +
  if (digits.startsWith('62')) {
    return '+' + digits;
  }

  // If already starts with +, return as is
  if (phone.startsWith('+')) {
    return phone;
  }

  // Default: assume Indonesian number
  return '+62' + digits;
};

// Format currency (Indonesian Rupiah)
export const formatCurrency = (amount, currency = 'IDR') => {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount || 0);
};

// Format number with thousand separators
export const formatNumber = (num) => {
  return new Intl.NumberFormat('id-ID').format(num || 0);
};

// Format date
export const formatDate = (date, options = {}) => {
  if (!date) return '';
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  };
  return new Date(date).toLocaleDateString('id-ID', defaultOptions);
};

// Format datetime
export const formatDateTime = (date) => {
  if (!date) return '';
  return new Date(date).toLocaleDateString('id-ID', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Validate Indonesian phone number
export const isValidIndonesianPhone = (phone) => {
  if (!phone) return false;
  const digits = phone.replace(/\D/g, '');
  // Indonesian numbers: 08xx (10-13 digits) or 628xx (11-14 digits)
  if (digits.startsWith('08') && digits.length >= 10 && digits.length <= 13) {
    return true;
  }
  if (digits.startsWith('628') && digits.length >= 11 && digits.length <= 14) {
    return true;
  }
  return false;
};

// Truncate text
export const truncateText = (text, maxLength) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Generate slug from text
export const generateSlug = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
};
